export const ROUTE_NAMES = {
  RegistrationType: 'choose_registration_mode',
  AutoPhotoFrontDNI: 'auto_photo_front_dni',
  AutoPhotoBackDNI: 'auto_photo_back_dni',
  EditFrontDNI: 'edit_front_side_dni_data',
  EditBackDNI: 'edit_back_side_dni_data',
  PersonalInfo: 'personal_work_info',
  BankInfo: 'edit_bank_account_data',
  PhotoFrontDNI: 'manual_photo_front_dni',
  PhotoBackDNI: 'manual_photo_back_dni',
  Selfie: 'selfie',
  CreateFirstApplication: 'create_first_application',
  ResolvedFirstApplication: 'resolved_first_application',
  ConfirmApplication: 'confirm_application', // NOTE: doesn't exist on BE, used here to avoid extra redirects
  PersonalAccount: 'personal_account',
  BlockedUser: 'oops',
  DocumentRequest: 'document_request',
  WaitingApplicationDecision: 'decision_ready_first_application',
  AddCardOnRegistration: 'add_payment_method',
  Registration: 'registration',
};

export const SHORT_LINK = 'https://p365.pe/';
